export const enum ArticleInspirePosition {
  postHeader = 'post_header',
  postFooter = 'post_footer',
  promptFooter = 'prompt_footer',
}
